import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// ui
import { Container } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MenuItem from '@material-ui/core/MenuItem';
// components
import DeleteModal from 'commons/components/DeleteModal';
import { truthty } from 'utils/functions';
import TableActionMenu from 'commons/components/TableActionMenu';
import ImportModal from 'commons/components/Modal';
import ClientForm from './ClientForm';
import Filters from './Filters';
import ItemList from './ItemList';
import { CLIENTS } from '../reducer';

function ClientsComponent(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [importModalOpen, setImportModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const importLoader = useSelector((state) => state?.clients.importing);
  const importLoaderSuccess = useSelector((state) => state?.clients.importSuccess);
  useEffect(() => {
    if (!importLoader) {
      setIsUploading(false);
    }
    if (importLoaderSuccess) {
      setImportModalOpen(false);
      setImportModalOpen(false);
      setSelectedFile(null);
    }
  }, [importLoader, importLoaderSuccess]);

  const handleImportModal = () => setImportModalOpen(true);
  const handleCloseImport = () => {
    setImportModalOpen(false);
    setSelectedFile(null);
  };

  const handleFileUpload = (file) => {
    setSelectedFile(file);
  };

  const handleImport = (type) => {
    if (selectedFile && !isUploading) {
      setIsUploading(true);
      setImportModalOpen(true);
      dispatch({
        type: CLIENTS.IMPORT_CLIENTS,
        payload: {
          file: selectedFile,
          type,
          socketId: props.socketId,
        },
      });
      setSelectedFile(null);
      setIsUploading(false);
    }
  };

  return (
    <>
      <Container maxWidth={false}>
        <Grid container spacing={3} className={props.classes.container}>
          <Grid item xs={12}>
            <Typography variant="h3" component="h2" className={props.classes.marginTop}>
              {t('Clients')}
            </Typography>
          </Grid>
          <Filters
            onFilterChange={props.onFilterChange}
            classes={props.classes}
            filter={props.filter}
          />
          <Grid container item>
            <Grid item xs={12} sm={4} md={3}>
              <TableActionMenu
                menuItems={[
                  {
                    label: t('Export'),
                    listItems: [
                      {
                        label: t('Excel file'),
                        onClick: props.actions.exportClients,
                        params: [Object.values(props.clientList)],
                      },
                    ],
                  },
                  {
                    label: t('Import'),
                    listItems: [
                      {
                        label: t('Bulk upload'),
                        onClick: handleImportModal,
                        params: [],
                      },
                    ],
                  },
                ]}
              />
            </Grid>
          </Grid>
          <ItemList
            classes={props.classes}
            objects={props.objects}
            toggleEdit={props.toggleEdit}
            toggleDelete={props.toggleDelete}
            clientList={props.clientList}
            anchorEl={props.anchorEl}
            handleClick={props.handleClick}
            handleClose={props.handleClose}
          />
        </Grid>
        <ClientForm
          isOpen={props.formIsOpen}
          toggleForm={props.toggleForm}
          changeControls={props.changeControls}
          onChange={props.actions.changeControls}
          controls={props.formControls}
          edit={props.edit}
          submit={props.submit}
          invalidControls={props.invalidControls}
          country={props.country}
        />
        <DeleteModal
          isOpen={props.deleteIsOpen}
          toggleForm={props.closeForm}
          submit={props.submitDelete}
          buttonId="delete-client"
          title={t('clients.deleteTitle')}
          message={t('clients.deleteMessage')}
        />
        <Fab
          color="primary"
          aria-label="add"
          className={props.classes.fab}
          onClick={props.toggleForm}>
          <AddIcon />
        </Fab>
        <Menu
          anchorEl={props.anchorEl}
          keepMounted
          open={truthty(props.anchorEl)}
          onClose={props.handleClose}>
          <MenuItem onClick={props.toggleEdit}>
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
            {t('Edit')}
          </MenuItem>
          <MenuItem onClick={props.toggleDelete}>
            <ListItemIcon>
              <DeleteIcon />
            </ListItemIcon>
            {t('Delete')}
          </MenuItem>
        </Menu>
      </Container>
      <ImportModal
        isOpen={importModalOpen}
        onClose={handleCloseImport}
        onImport={handleImport}
        onUploadFile={handleFileUpload}
        type="clients"
        selectedFile={selectedFile}
        isUploading={isUploading}
      />
    </>
  );
}

export default ClientsComponent;
